<template>
    <div class="bg-gray-900 p-4">
        <template v-for="year in years">
            <router-link :to="`/gallery/`" :key="year.id">
                <app-year class="" :year="year" :key="year.id"></app-year>
            </router-link>
        </template>
    </div>
</template>

<script>
import Year from './Year'
import years from '../../data/years'

export default {
    name: 'Timeline',
    data() {
        return years
    },
    components: {
        'app-year': Year
    }

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/timeline/Container.vue